import { z } from "zod";
import { UserRolesSchema } from "./user.ts";

export const grafitUserSchema = z.object({
  imageUrl: z.string().optional(),
  email: z.string(),
  fullName: z.string(),
  id: z.string(),
  isGrafitAdmin: z.boolean(),
  phoneNumber: z.string().optional(),
  jobTitle: z.string().optional(),
  trigram: z.string().optional(),
});

export const grafitUserWithRolesSchema = grafitUserSchema.extend({
  roles: UserRolesSchema,
});
